function identity(x) {
    return x;
}

export { identity };
